import { Box, Typography } from '@mui/material';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionProforientation } from 'icons/widgets';
import LinkContainer from 'portfolio3/features/proforientation/components/LinkContainer';
import { proforientationResultLinkSelector } from 'portfolio3/features/proforientation/model/selectors';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { getDataLoadRequests } from 'utils';

import PdfNoDataText from '../../../../portfolio3/features/pdf/components/PdfNoDataText';
import PdfCommonDataEntityContainer from '../common';

const PdfProforientation = () => {
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionProforientation });
  const resultLink = useAppSelector(proforientationResultLinkSelector);

  emitYMEvent({ type: 'main_popUpArchiveSearch_goService_open' });
  return (
    <PdfCommonDataEntityContainer title="Профориентация" Icon={IconWidgetProfessionProforientation}>
      {resultLink ? (
        <Box>
          <Typography variant="Paragraph LG/Regular">
            Здесь ты можешь ознакомиться с результатами тестирования и скачать их
          </Typography>
          <LinkContainer sx={{ fontSize: '15px' }} link={resultLink ?? ''}>
            Скачать результаты
          </LinkContainer>
        </Box>
      ) : (
        <PdfNoDataText />
      )}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfProforientation;
